import { render, staticRenderFns } from "./97.vue?vue&type=template&id=fa5e45d4&scoped=true&"
var script = {}
import style0 from "./97.vue?vue&type=style&index=0&id=fa5e45d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5e45d4",
  null
  
)

export default component.exports